const {enabled}=require('./transition.js');
const pointer=matchMedia('(hover: hover) and (pointer: fine)');
const canvases=[...document.querySelectorAll('[data-work-hall] .one-work__canvas')];
let frame=0,active=null,x=0,y=0;
const properties=['--work-pointer-x','--work-pointer-y','--work-light-x','--work-light-y'];
const paint=()=>{
 frame=0;
 if(!active)return;
 active.style.setProperty('--work-pointer-x',x.toFixed(3));
 active.style.setProperty('--work-pointer-y',y.toFixed(3));
 active.style.setProperty('--work-light-x',`${((x+.5)*100).toFixed(2)}%`);
 active.style.setProperty('--work-light-y',`${((y+.5)*100).toFixed(2)}%`);
};
const reset=()=>{
 cancelAnimationFrame(frame);frame=0;
 if(active)properties.forEach(name=>active.style.removeProperty(name));
 active=null;
};
canvases.forEach(canvas=>{
 canvas.addEventListener('pointermove',event=>{
  if(event.pointerType!=='mouse'||!pointer.matches||!enabled())return;
  const rect=canvas.getBoundingClientRect();
  if(!rect.width||!rect.height)return;
  if(active&&active!==canvas)reset();
  active=canvas;
  x=Math.max(-.5,Math.min(.5,(event.clientX-rect.left)/rect.width-.5));
  y=Math.max(-.5,Math.min(.5,(event.clientY-rect.top)/rect.height-.5));
  if(!frame)frame=requestAnimationFrame(paint);
 });
 canvas.addEventListener('pointerleave',()=>{if(active===canvas)reset();});
 canvas.addEventListener('pointercancel',()=>{if(active===canvas)reset();});
});
pointer.addEventListener('change',reset);
addEventListener('onestep:motion',reset);
addEventListener('blur',reset);
addEventListener('resize',reset);
document.addEventListener('visibilitychange',()=>{if(document.hidden)reset();});
